import { CATEGORY_POI, POI, POI_PARAM, POI_FLEETGROUP } from '../constant'
import axios from 'axios'
import * as REPO from '../helper/main'

const localKey = 'token'

export const getListCategoryPOI = () => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(CATEGORY_POI, config_token)
}

export const getOneCategoryPOI = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(`${CATEGORY_POI}/${id}`, config_token)
}

export const postCategoryPOI = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(CATEGORY_POI, data, config_token)
}

export const deleteCategoryPOI = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.delete(`${CATEGORY_POI}/${id}`, config_token)
}

export const updateCategoryPOI = (data, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(CATEGORY_POI + '/' + id, data, config_token)
}

export const updatePoiFleetgroup = (data, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(POI_FLEETGROUP + id, data, config_token)
}
// POI

export const getPOIDetail = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(POI + '/' + id, config_token)
}

export const postPOI = (data) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(POI, data, config_token)
}

export const putPOI = (data, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.put(POI + '/' + id, data, config_token)
}

export const deletePOI = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.delete(`${POI}/${id}`, config_token)
}

export const getPOI = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(`${POI}?category_poi_id=${id}`, config_token)
}

export const getPOIParam = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  // let param = REPO.bikinParam(body);
  return axios.post(POI_PARAM, body, config_token)
}

// export const getPOIParam= body => {
//     let config_token={
//         headers : REPO.getAuthHeader()
//     };
//     let param = REPO.bikinParam(body);
//     return axios.get(`${POI}?${param}`,  config_token);
// };
